<div class="d-flex justify-content-center">
   <div [ngClass]="requests.length > 0 ? 'remove-bottom-curve' : 'remove-curve'" class="card  col-lg-10 col-md-10 col-sm-12 col-12">
      <div class="scroll">
         <table class="table standard-table table-borderless">
            <h2 id="table-title">Pending Request(s)</h2>
            <p *ngIf="requests && requests.length > 0" class="mobile-arial hidden-ss">You must complete and submit the<br > information below for us to
                  receive your<br> request(s).</p>

            <div id="no-requests" class="big-left-marg" *ngIf="!requests || requests.length == 0">No requests added yet</div>
            <ng-container *ngIf="requests && requests.length > 0">
               <thead >
                  <th class ="no-underline big-left-pad" >
                     Request For
                  </th >
                  <th class ="no-underline">
                     Request Details
                  </th>
                  <th class ="no-underline">
                     Actions
                  </th>
               </thead>
               <tbody >
                  <tr *ngFor="let row of requests; let i = index">
                     <td class="big-left-pad">
                        <div class="arial">
                           {{row.name | textSlice}} <span *ngIf="row.middleInitial">{{row.middleInitial}} </span> <span *ngIf="row.lastName">{{row.lastName | textSlice}}</span>
                        </div>
                        <div class="grey-font arial">
                           {{ row.providerType | providerPipe }}
                        </div>
                     </td>
                     <td>
                        <div class="arial">
                           {{ row.providerType + row.requestType | requestType }}
                        </div>
                        <div class="grey-font arial">
                           {{ row.requestDetails | textSlice }}
                        </div>
                        <div *ngIf="row.doc">
                           <a href="#" download="{{row.doc.name}}" class="a" (click)="getDocument(row.doc)" *ngIf="IE"><span class="uline small-font">{{ row.doc.name | textSlice }}</span> </a>
                           <a [href]="document" download="{{row.doc.name}}" class="a" (click)="getDocument(row.doc)" *ngIf="!IE" > <span class="uline small-font">{{ row.doc.name | textSlice }}</span> </a>
                        </div>
                        <div *ngFor="let optDoc of row.optDocs">
                           <a href="#" download="{{optDoc.name}}" class="a" (click)="getDocument(optDoc)" *ngIf="IE"><span class="uline small-font">{{ optDoc.name | textSlice }}</span> </a>
                           <a [href]="document" download="{{optDoc.name}}" class="a" (click)="getDocument(optDoc)" *ngIf="!IE" > <span class="uline small-font">{{ optDoc.name | textSlice }}</span> </a>
                        </div>
                     </td>
                     <td>
                        <div>
                           <a (click)="editRequest(i, row.requestType, row.providerType)"><span class="uline">Edit</span></a> |
                           <a (click)="duplicateRequest(i, row.providerType)"><span class="uline">Duplicate</span></a> |
                           <a (click)="deleteRequest(i)"><span class="uline">Delete</span></a>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </ng-container>
         </table>
      </div>
   </div>
</div>
<app-contact *ngIf="requests && requests.length > 0"></app-contact>
<app-duplicate-modal></app-duplicate-modal>
<app-ind-prov-modal></app-ind-prov-modal>
<app-delete-modal></app-delete-modal>
<app-dent-prac-modal></app-dent-prac-modal>